import React, { useState, useEffect } from 'react';
import '../styles/Actualites.css';
import { getAllActualites } from '../services/api';

function Actualites() {
  const [selectedCategory, setSelectedCategory] = useState('tous');
  const [actualites, setActualites] = useState([]);
  const [loading, setLoading] = useState(true);

  const API_BASE_URL =
    process.env.REACT_APP_API_URL?.replace(/\/api\/?$/, '') || 'http://localhost:5001';

  useEffect(() => {
    fetchActualites();
  }, []);

  const fetchActualites = async () => {
    try {
      const response = await getAllActualites();
      setActualites(response.data);
    } catch (error) {
      console.error('Erreur chargement actualités:', error);
    } finally {
      setLoading(false);
    }
  };

  const getImageUrl = (imagePath) => {
    if (!imagePath) return null;
    if (imagePath.startsWith('http')) return imagePath;
    return `${API_BASE_URL}${imagePath}`;
  };

  const placeholderSvg =
    'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="400" height="300"%3E%3Crect width="400" height="300" fill="%232c5f2d"/%3E%3Ctext x="50%25" y="50%25" font-size="20" fill="white" text-anchor="middle" dy=".3em"%3EImage à venir%3C/text%3E%3C/svg%3E';

  const filteredActualites =
    selectedCategory === 'tous'
      ? actualites
      : actualites.filter((item) => item.category === selectedCategory);

  if (loading) {
    return (
      <div className="actualites-container">
        <div style={{ textAlign: 'center', padding: '100px 20px' }}>
          <h2>Chargement des actualités...</h2>
        </div>
      </div>
    );
  }

  return (
    <div className="actualites-container">
      <section className="actualites-hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1>Actualités & Projets</h1>
          <p>
            Découvrez nos réalisations, nos partenariats et nos engagements depuis la création de
            l'association
          </p>
        </div>
      </section>

      <section className="actualites-main">
        <div className="container">
          <div className="section-header">
            <h2>Les Projets Partenaires & nos Engagements</h2>
            <p className="section-description">
              Depuis notre création, nous menons et soutenons de nombreux projets en partenariat avec
              des associations locales et internationales pour le développement des Comores.
            </p>
          </div>

          
            <div className="filters">
              {['tous', 'projet', 'evenement', 'presse', 'permanence'].map((cat) => (
                <button
                  key={cat}
                  className={`filter-btn ${selectedCategory === cat ? 'active' : ''}`}
                  onClick={() => setSelectedCategory(cat)}
                >
                  {{ tous: 'Tous', projet: 'Projets', evenement: 'Événements', presse: 'Presse', permanence: 'Permanence Numérique' }[cat]}
                </button>
              ))}
            </div>

          <div className="actualites-grid">
            {filteredActualites.map((item) => (
              <div key={item._id} className="actualite-card">
                {/* ===== IMAGES (carrousel simple si plusieurs) ===== */}
                <CardImages item={item} getImageUrl={getImageUrl} placeholder={placeholderSvg} />

                <div className="card-content">
                  <div className="card-date">
                    <span className="date-icon">📅</span>
                    {item.date}
                  </div>
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>

                  <div className="card-tags">
                    {item.tags.map((tag, index) => (
                      <span key={index} className="tag">
                        {tag}
                      </span>
                    ))}
                  </div>

                  {/* ===== LIENS MULTIPLES ===== */}
                  {item.links && item.links.length > 0 && (
                    <div className="card-links">
                      {item.links.map((link, i) => (
                        
                         <a key={i}
                          href={link.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn-voir-plus"
                        >
                          {link.label || 'Voir plus'} →
                        </a>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>

          {filteredActualites.length === 0 && (
            <div className="no-results">
              <p>Aucune actualité dans cette catégorie pour le moment.</p>
            </div>
          )}
        </div>
      </section>

      <section className="cta-section">
        <div className="container">
          <h2>Soutenez nos projets</h2>
          <p>Ensemble, nous pouvons faire encore plus pour le développement des Comores</p>
          <div className="cta-buttons">
            <a href="/benevole" className="btn btn-primary">
              Devenir bénévole
            </a>
            <a href="/contact" className="btn btn-secondary">
              Nous contacter
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

// ===========================
// Sous-composant carrousel images
// ===========================
function CardImages({ item, getImageUrl, placeholder }) {
  const [currentIndex, setCurrentIndex] = useState(0);

  const images = item.images && item.images.length > 0 ? item.images : [];
  const hasMultiple = images.length > 1;

  const goTo = (dir) => {
    setCurrentIndex((prev) => {
      if (dir === 'next') return (prev + 1) % images.length;
      return (prev - 1 + images.length) % images.length;
    });
  };

  // Aucune image
  if (images.length === 0) {
    return (
      <div className="card-image">
        <img src={placeholder} alt={item.title} />
        <span className="card-badge">{item.type}</span>
      </div>
    );
  }

  return (
    <div className="card-image" style={{ position: 'relative' }}>
      <img
        src={getImageUrl(images[currentIndex])}
        alt={`${item.title} ${currentIndex + 1}`}
        onError={(e) => {
          e.target.src = placeholder;
        }}
      />
      <span className="card-badge">{item.type}</span>

      {/* Flèches navigation */}
      {hasMultiple && (
        <>
          <button
            onClick={(e) => {
              e.stopPropagation();
              goTo('prev');
            }}
            className="carousel-arrow carousel-arrow-left"
            aria-label="Image précédente"
          >
            ‹
          </button>
          <button
            onClick={(e) => {
              e.stopPropagation();
              goTo('next');
            }}
            className="carousel-arrow carousel-arrow-right"
            aria-label="Image suivante"
          >
            ›
          </button>

          {/* Dots indicateurs */}
          <div className="carousel-dots">
            {images.map((_, i) => (
              <span
                key={i}
                className={`carousel-dot ${i === currentIndex ? 'active' : ''}`}
                onClick={(e) => {
                  e.stopPropagation();
                  setCurrentIndex(i);
                }}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
}

export default Actualites;